import { Controller } from "@hotwired/stimulus"

// Drives the fast_init first-run page: picking a client (an existing chip or a
// new name) unlocks the format section and keeps every form's hidden client
// fields in sync. Selecting an existing client hides the "add new" area;
// clicking the selected chip again clears the selection and shows it back.
export default class extends Controller {
  static targets = [
    "clientChip",
    "clientNameInput",
    "newClientArea",
    "formatSection",
    "blockedHint",
    "existingHint",
    "clientIdField",
    "clientNameField",
    "uploadSubmit"
  ]

  connect() {
    this.selectedClientId = ""
    this.selectedClientName = ""
    this.fileSelected = false
    this.refresh()
  }

  selectClient(event) {
    const chip = event.currentTarget

    if (chip.dataset.clientId === this.selectedClientId) {
      this.clearChips()
      this.selectedClientId = ""
      this.toggleNewClientArea(true)
    } else {
      this.clientChipTargets.forEach((candidate) => {
        const active = candidate === chip
        candidate.classList.toggle("border-indigo-500", active)
        candidate.classList.toggle("bg-indigo-50", active)
        candidate.classList.toggle("text-indigo-700", active)
      })
      this.clientNameInputTarget.value = ""
      this.selectedClientId = chip.dataset.clientId
      this.selectedClientName = ""
      this.toggleNewClientArea(false)
    }

    this.syncFields()
    this.refresh()
  }

  typeClient() {
    const name = this.clientNameInputTarget.value.trim()
    if (name.length > 0) {
      this.clearChips()
      this.selectedClientId = ""
    }
    this.selectedClientName = name
    this.syncFields()
    this.refresh()
  }

  filesChanged(event) {
    this.fileSelected = event.detail.count > 0
    this.refresh()
  }

  clearChips() {
    this.clientChipTargets.forEach((chip) => {
      chip.classList.remove("border-indigo-500", "bg-indigo-50", "text-indigo-700")
    })
  }

  toggleNewClientArea(visible) {
    if (this.hasNewClientAreaTarget) {
      this.newClientAreaTarget.classList.toggle("hidden", !visible)
    }
  }

  syncFields() {
    this.clientIdFieldTargets.forEach((field) => { field.value = this.selectedClientId })
    this.clientNameFieldTargets.forEach((field) => { field.value = this.selectedClientName })
  }

  get hasClient() {
    return this.selectedClientId.length > 0 || this.selectedClientName.length > 0
  }

  refresh() {
    const blocked = !this.hasClient
    this.formatSectionTarget.classList.toggle("opacity-50", blocked)
    this.formatSectionTarget.classList.toggle("pointer-events-none", blocked)
    this.formatSectionTarget.setAttribute("aria-disabled", String(blocked))
    if (this.hasBlockedHintTarget) this.blockedHintTarget.classList.toggle("hidden", !blocked)
    if (this.hasExistingHintTarget) this.existingHintTarget.classList.toggle("hidden", blocked)
    this.uploadSubmitTargets.forEach((button) => {
      button.disabled = blocked || !this.fileSelected
    })
  }
}
